import React, { useState } from "react";
import { Button } from "../../../../../../../../../shared/Button/Button";
import { EditIcon } from "../../../../../../../../../assets/Icons/EditIcon";
import { DeleteIcon } from "../../../../../../../../../assets/Icons/DeleteIcon";
import styles from "./styles.module.scss";
import { history } from "../../../../../../../../../history";
import { SETTINGS_ROUTES } from "../../../../../../../../../consts/routes";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { useDelete } from "../../../../hooks/useDelete";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";

export const Actions = ({ id }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "smsSnippets",
  });

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const del = useDelete();

  const close = () => setConfirmDeleteOpen(false);

  return (
    <div className={styles.root}>
      <Button
        size="tiny"
        variant="outlined"
        onClick={() => history.push(SETTINGS_ROUTES.smsSnippets.edit(id))}
      >
        <EditIcon width="16px" />
      </Button>
      <Button
        size="tiny"
        variant="outlined"
        color="error"
        onClick={() => setConfirmDeleteOpen(true)}
      >
        <DeleteIcon width="16px" />
      </Button>
      {confirmDeleteOpen && (
        <ConfirmModal
          isOpen
          isConfirming={del.isLoading}
          onClose={close}
          onCancel={close}
          onConfirm={() => del.initiate(id).then(close)}
        >
          {t("confirm.deleteOne")}
        </ConfirmModal>
      )}
    </div>
  );
};
